import IntentType from "../../intentexecutor/utils/IntentType";
import MemoryType from "../../service/memory/enum/MemoryType";
import LocalStorageHandler from "../../service/memory/handler/LocalStorageHandler";
import { performPostRequest } from "../../service/network/NetworkService";
import { getApiUrl } from "../../service/network/UrlMapper";
import { convertTimeToTimestamp } from "../../utils/dateutils";

const localStorage = new LocalStorageHandler();

export const publishEvent = async (type, user, current, previous) => {
  const loggedInUser = localStorage.read(MemoryType.USER);
  const organizationIdentifier = loggedInUser?.organizationIdentifier

  let currentValues = {
    userIdentifier: user?.userIdentifier,
  };
  let previousValues = {};

  if (current) {
    currentValues = {...current}
  }
  if (previous) {
    previousValues = {...previous}
  }

  const eventPayload = {
    associatedEntities: [
      {
        workforce: user?.userIdentifier,
        organizationIdentifier
      },
    ],
    originId: "niramaya",
    originTimestamp: convertTimeToTimestamp(new Date()),
    type: type,
    userName: `${user?.givenName} ${user?.familyName}`,
    payload: {
      currentValues,
      previousValues,
    },
  };
  await performPostRequest(
    getApiUrl()[IntentType.SEND_EVENT],
    JSON.stringify(eventPayload),
  );
};
